import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Check, Circle, ChevronDown, ChevronRight, Trophy } from "lucide-react";

export interface Milestone {
  key: string;
  label: string;
  done: boolean;
}

interface Props {
  milestones: Milestone[];
}

/** Simple checkmark list — no points, no badges, no trophies for the user. */
export function MilestonesPanel({ milestones }: Props) {
  const [open, setOpen] = useState(false);
  const doneCount = milestones.filter((m) => m.done).length;
  return (
    <Card>
      <CardHeader className="pb-2">
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          className="flex items-center justify-between w-full text-left"
        >
          <CardTitle className="text-base font-semibold flex items-center gap-2">
            {open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
            <Trophy className="h-4 w-4 text-[hsl(var(--status-success))]" />
            Milestones
          </CardTitle>
          <span className="text-xs text-muted-foreground">{doneCount}/{milestones.length} complete</span>
        </button>
      </CardHeader>
      {open && (
        <CardContent>
          <ul className="space-y-2">
            {milestones.map((m) => (
              <li key={m.key} className="flex items-center gap-3">
                {m.done ? (
                  <Check className="h-4 w-4 text-[hsl(var(--status-success))]" />
                ) : (
                  <Circle className="h-4 w-4 text-muted-foreground" />
                )}
                <span className={m.done ? "text-sm" : "text-sm text-muted-foreground"}>{m.label}</span>
              </li>
            ))}
          </ul>
        </CardContent>
      )}
    </Card>
  );
}